export enum AiColEnrichmentModalSteps {
  ENRICH_OPTION = 'ENRICH_OPTION',
  TEMPLATE_LIST = 'TEMPLATE_LIST',
  TEMPLATE_DETAIL = 'TEMPLATE_DETAIL',
  CUSTOM_PROMPT = 'CUSTOM_PROMPT',
  EXISTING_COLUMN = 'EXISTING_COLUMN',
}

export enum SupportedAiModelsOutput {
  Default = 'default',
  CommaSeparatedValues = 'commaSeparatedValues',
  OneWord = 'oneWord',
  Email = 'email',
  BulletPoints = 'bulletPoints',
  NumberList = 'numberList',
  HtmlSnippet = 'htmlSnippet',
  LinkOnly = 'linkOnly',
  SingleSentence = 'singleSentence',
  ShortParagraph = 'shortParagraph',
  LongParagraph = 'longParagraph',
  Custom = 'custom',
}

// ** All below are approximate character lengths for the output format
export enum OutputFormatApproxCharLength {
  default = 700,
  commaSeparatedValues = 300,
  oneWord = 20,
  email = 100,
  bulletPoints = 250,
  numberList = 200,
  htmlSnippet = 800,
  linkOnly = 100,
  singleSentence = 200,
  shortParagraph = 600,
  longParagraph = 1200,
  longText = 5000,
  plainText = 1000,
  number = 1000,
}



export enum SupportedAiModelsServiceProvider {
  OpenAI = 'openai',
  Anthropic = 'anthropic',
  Google = 'google',
  Perplexity = 'perplexity',
  XAI = 'x-ai',
}

export enum EnrichmentTemplateCategory {
  MarketResearcher = 'marketResearcher',
  CompanyDataLookup = 'companyDataLookup',
  DataCleanup = 'dataCleanup',
  PeopleDataFinder = 'peopleDataFinder',
  DataClassifier = 'dataClassifier',
  SocialMedia = 'socialMedia',
  Miscellaneous = 'miscellaneous',
  ColdEmailAssistant = 'coldEmailAssistant',
  UserDefined = 'userDefined',
}

export enum SupportedAiModelsOutputColumnType {
  PlainText = 'plainText',
  LongText = 'longText',
  Number = 'number',
}

export enum AiColumnsActionType {
  SaveAndRunForFirst10Rows = 'saveAndRunForFirst10Rows',
  SaveAndRunForAllRows = 'saveAndRunForAllRows',
  SaveAndRunForEmptyRows = 'saveAndRunForEmptyRows',
  SaveAndRunForSelectedRows = 'saveAndRunForSelectedRows',
  SaveAndDontRun = 'saveAndDontRun',
}

